module.exports = __webpack_public_path__ + "img/31.d88d4768.png";